import { useEffect } from "react";

type loadScriptParams = {
  url: string;
  onLoad?: () => void;
  onError?: (...arg: unknown[]) => void;
  cleanup?: () => void;
};

const getScriptByUrl = (url: string) => {
  const script = document.querySelector<HTMLScriptElement>(
    `script[src='${url}']`
  );

  return script;
};

export default function useLoadScript(params: loadScriptParams) {
  const { url, onLoad, onError, cleanup } = params;
  useEffect(() => {
    let script = getScriptByUrl(url);
    const exists = script !== null;

    if (!script) {
      script = document.createElement("script");
      script.src = url;
      script.async = true;
    } else {
      if (script.hasAttribute("loaded") && onLoad) {
        onLoad();
      }

      if (script.hasAttribute("error") && onError) {
        onError();
      }
    }

    if (onLoad) {
      script.addEventListener("load", () => {
        script?.setAttribute("loaded", "true");
        onLoad();
      });
    }

    if (onError) {
      script.addEventListener("error", () => {
        script?.setAttribute("error", "true");
        onError();
      });
    }

    if (!exists) {
      document.body.appendChild(script);
    }

    return () => {
      if (!script) return;
      console.log("unmounting script ...");
      document.body.removeChild(script);
      cleanup && cleanup();
    };
  }, [url, onLoad, onError, cleanup]);
}
